if (!customElements.get('pb-first-order-planner')) {
  customElements.define('pb-first-order-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.panel = this.querySelector('.pb-order-layout > .pb-order-answer');
      this.status = this.querySelector('.pb-order-status');
      this.radios = [...this.querySelectorAll('.pb-order-input')];
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      this.animations = new Set();
      this.pointerSelection = false;
      this.revealed = false;
      const listener = {signal: this.controller.signal};
      this.querySelector('.pb-order-fallback')?.remove();
      this.classList.add('is-ready');
      this.addEventListener('pointerdown', () => {
        this.settle();
        this.pointerSelection = true;
      }, listener);
      this.addEventListener('keydown', () => {
        this.pointerSelection = false;
        this.settle();
      }, listener);
      this.addEventListener('change', event => {
        if (!this.radios.includes(event.target)) return;
        this.select(event.target);
      }, listener);
      window.addEventListener('resize', () => this.settle(), listener);
      this.reduce.addEventListener('change', () => this.settle(), listener);
      const checked = this.radios.find(radio => radio.checked);
      if (checked) this.select(checked);
    }

    play(element, keyframes, settings) {
      const animation = element.animate(keyframes, settings);
      this.animations.add(animation);
      animation.finished.then(
        () => this.animations.delete(animation),
        () => this.animations.delete(animation)
      );
    }

    settle() {
      for (const animation of this.animations) animation.cancel();
      this.animations.clear();
    }

    select(radio) {
      const template = this.querySelector(`template[data-order-answer="${radio.value}"]`);
      if (!template) return;
      const firstChoice = !this.revealed;
      const animate = this.pointerSelection && typeof this.animate === 'function';
      this.pointerSelection = false;
      this.settle();
      const moving = animate && !this.reduce.matches
        ? [...this.querySelectorAll('.pb-order-surface, .pb-order-art, .pb-order-choice strong, .pb-order-mark')]
        : [];
      const before = moving.map(element => element.getBoundingClientRect());
      const opened = this.panel.querySelector('details')?.open || false;
      this.panel.replaceChildren(template.content.cloneNode(true));
      this.panel.querySelector('details').open = opened;
      this.panel.hidden = false;
      this.panel.setAttribute('aria-labelledby', this.panel.querySelector('h3').id);
      this.classList.add('has-answer');
      this.revealed = true;
      for (const input of this.radios) {
        const item = input.closest('.pb-order-item');
        item.classList.toggle('is-selected', input.checked);
        item.querySelector('.pb-order-mark').textContent = input.checked ? '✓' : '';
      }
      this.status.textContent = this.panel.querySelector('[data-announcement]').dataset.announcement;
      if (!animate) return;
      const tokens = getComputedStyle(this);
      const moveDuration = parseFloat(tokens.getPropertyValue('--pb-order-move-duration'));
      const revealDuration = parseFloat(tokens.getPropertyValue('--pb-order-reveal-duration'));
      moving.forEach((element, index) => {
        const after = element.getBoundingClientRect();
        if (!after.width || !after.height) return;
        const surface = element.classList.contains('pb-order-surface');
        const artwork = element.classList.contains('pb-order-art');
        const scaleX = surface || artwork ? before[index].width / after.width : 1;
        const scaleY = surface ? before[index].height / after.height : scaleX;
        const dx = before[index].left - after.left;
        const dy = before[index].top - after.top;
        if (Math.abs(dx) < .5 && Math.abs(dy) < .5 && Math.abs(scaleX - 1) < .002 && Math.abs(scaleY - 1) < .002) return;
        this.play(element, [
          {transform: `translate(${dx}px, ${dy}px) scale(${scaleX}, ${scaleY})`},
          {transform: 'translate(0, 0) scale(1, 1)'}
        ], {duration: moveDuration, easing: tokens.getPropertyValue('--pb-order-ease-in-out').trim()});
      });
      if (!firstChoice) return;
      const enter = matchMedia('(max-width: 760px)').matches ? 'translateY(16px)' : 'translateX(24px)';
      this.play(this.panel, this.reduce.matches
        ? [{opacity: 0}, {opacity: 1}]
        : [{opacity: 0, transform: enter}, {opacity: 1, transform: 'translate(0, 0)'}], {
        duration: revealDuration,
        delay: this.reduce.matches ? 0 : parseFloat(tokens.getPropertyValue('--pb-order-reveal-delay')),
        fill: 'backwards',
        easing: tokens.getPropertyValue('--pb-order-ease-out').trim()
      });
    }

    disconnectedCallback() {
      this.settle();
      this.controller.abort();
      this.controller = null;
    }
  });
}
